import { Button } from "@stackje/shared-components/ui/button";

interface StandardErrorDisplayProps {
  error: unknown;
  resetError?: () => void;
  onRetry?: () => void;
}

export function StandardErrorDisplay({ 
  error, 
  resetError, 
  onRetry 
}: StandardErrorDisplayProps) {
  const errorMessage = error instanceof Error ? error.message : 'An unexpected error occurred';
  
  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else if (resetError) {
      resetError();
    } else {
      window.location.reload();
    }
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full space-y-6 text-center">
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-gray-900">Something went wrong</h1>
          <p className="text-gray-600">
            We've encountered an unexpected error. If the problem persists, please <a href="mailto:support@stack.je" className="text-blue-500 underline">contact support</a>.
          </p>
        </div>
        
        <div className="bg-gray-100 p-4 rounded-lg">
          <p className="text-sm text-gray-700 font-mono break-all">
            {errorMessage}
          </p>
        </div>
        
        <div className="space-y-3">
          <Button 
            onClick={handleRetry}
            className="w-full"
          >
            Try again
          </Button>
          <Button 
            variant="outline"
            onClick={handleGoHome}
            className="w-full"
          >
            Go to home
          </Button>
        </div>
      </div>
    </div>
  );
}